"use client";

import React, { useEffect } from "react";
import { useParams } from "next/navigation";
import { SlidersHorizontal, X } from "lucide-react";
import FilterBar from "./FilterBar";
import styles from "./mobileFilterDrawer.module.css";

interface MobileFilterDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  selectedDmnvts: string[];
  onDmnvtChange: (ids: string[]) => void;
  onReset: () => void;
  allowedNganhHang?: string[];
  groupDefinitions?: { ma_nganh_hang: string; name: string }[];
  productCount?: number;
  locale?: string;
}

export default function MobileFilterDrawer({
  isOpen,
  onClose,
  selectedDmnvts,
  onDmnvtChange,
  onReset,
  allowedNganhHang,
  groupDefinitions,
  productCount = 0,
  locale,
}: MobileFilterDrawerProps) {
  const params = useParams();
  const currentLocale = locale || (params?.locale as string) || "vi";
  const isEn = currentLocale === "en";

  // Prevent body scrolling when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div
        className={styles.panel}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={isEn ? "Product filters" : "Bộ lọc sản phẩm"}
      >
        {/* Header */}
        <div className={styles.drawerHeader}>
          <div className={styles.headerLeft}>
            <SlidersHorizontal size={18} />
            <h3 className={styles.drawerTitle}>
              {isEn ? "Product Filters" : "Bộ Lọc Sản Phẩm"}
            </h3>
          </div>
          <button
            type="button"
            className={styles.closeBtn}
            onClick={onClose}
            aria-label={isEn ? "Close filters" : "Đóng bộ lọc"}
          >
            <X size={20} />
          </button>
        </div>

        {/* Content Body */}
        <div className={styles.drawerBody}>
          <FilterBar
            selectedDmnvts={selectedDmnvts}
            onDmnvtChange={onDmnvtChange}
            onReset={onReset}
            allowedNganhHang={allowedNganhHang}
            groupDefinitions={groupDefinitions}
            locale={currentLocale}
          />
        </div>

        {/* Footer */}
        <div className={styles.drawerFooter}>
          <button
            type="button"
            className={styles.resetBtn}
            onClick={onReset}
          >
            {isEn ? "Reset" : "Đặt lại"}
          </button>
          <button
            type="button"
            className={styles.applyBtn}
            onClick={onClose}
          >
            {isEn ? `View results (${productCount})` : `Xem kết quả (${productCount})`}
          </button>
        </div>
      </div>
    </div>
  );
}
